module.exports = __webpack_public_path__ + "img/valimail3.24de79f0.png";